import {
  Checkbox,
  CheckboxProps,
  Stack,
  StackProps,
  FormControl,
  FormLabel,
  FormControlProps,
  FormErrorMessage,
} from '@chakra-ui/react';
import { Field, FieldProps, ErrorMessage, FieldAttributes } from 'formik';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface IFormikCheckboxProps {
  name: string;
  options: Array<ILabelValueOptions>;
  label?: string;
  formControlProps?: FormControlProps;
  checkboxProps?: CheckboxProps;
  stackProps?: StackProps;
  fieldProps?: FieldAttributes<any>;
  onChangeCallback?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBeforeChangeCallback?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormikCheckbox: React.FC<IFormikCheckboxProps> = ({
  name,
  label,
  formControlProps,
  options,
  checkboxProps,
  stackProps,
  fieldProps,
  onChangeCallback,
  onBeforeChangeCallback,
}) => {
  const { t } = useTranslation();

  return (
    <Field name={name} {...fieldProps}>
      {({ field, meta }: FieldProps) => (
        <FormControl mb="5" {...formControlProps} id={name} isInvalid={(meta.error && meta.touched) || false}>
          {label ? (
            <FormLabel
              htmlFor={name}
              color="gray.500"
              fontSize="12px"
              fontWeight="600"
              mb="1"
              textTransform="uppercase"
            >
              {label}
            </FormLabel>
          ) : null}
          <Stack alignItems="flex-start" {...stackProps}>
            {options.map(({ label, value }) => {
              return (
                <React.Fragment key={value}>
                  <Checkbox
                    {...field}
                    colorScheme="primary"
                    sx={{ '& .chakra-checkbox__label': { fontSize: 'sm' } }}
                    value={value}
                    isChecked={Array.isArray(meta.value) ? meta.value.includes(value) : false}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (onBeforeChangeCallback) {
                        onBeforeChangeCallback(e);
                      }

                      field.onChange(e);
                      if (onChangeCallback) {
                        onChangeCallback(e);
                      }
                    }}
                    {...checkboxProps}
                  >
                    {label}
                  </Checkbox>
                </React.Fragment>
              );
            })}
          </Stack>
          <ErrorMessage
            name={name}
            render={(error: any) => (
              <FormErrorMessage fontSize="13px" mt="1" display="block">
                {t(error.msg, { value: error.value })}
              </FormErrorMessage>
            )}
          />
        </FormControl>
      )}
    </Field>
  );
};

export default memo(FormikCheckbox);
